import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { Organization } from '../../models';
import { TeamDataService, OrganizationDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { TeamForm } from './TeamForm';
import { UserStore } from '../../stores';
import { Roles } from '../../stores/Constants';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import { PVAPage } from '../../components';

interface TeamCreateState {
    organizations: Organization[];
}

interface TeamCreateProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
}

@inject('UserStore') @observer
export class TeamCreate extends React.Component<TeamCreateProps, TeamCreateState> {
    private teamDataService = new TeamDataService(this.props.notificationService);
    private organizationDataService = new OrganizationDataService(this.props.notificationService);

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get organization() {
        return this.props.UserStore!.userInfo.organization;
    }

    constructor(props: TeamCreateProps) {
        super(props);

        this.state = {
            organizations: new Array<Organization>()
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        if (this.props.UserStore!.userRoleIn([Roles.OrgAdmin, Roles.Manager, Roles.User])) {
            this.organizationDataService.get(this.organization!.id).then((organization: Organization) => {
                this.setState({ organizations: [organization] });
            });
        } else {
            this.organizationDataService.getAll().then((organizations: Organization[]) => {
                this.setState({ organizations: organizations });
            });
        }
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/team`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Create Team
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <TeamForm UserStore={this.props.UserStore} submit={this.save} organizations={this.state.organizations} notificationService={this.props.notificationService} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.teamDataService.create(values).then((success) => {
            this.props.history.push('/team');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/team/TeamCreate.tsx